<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="drDeleteRows.length == 0">* 클릭 하시면 상세내역 페이지로 이동합니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="drDeleteRows.length > 0">선택된 데이터 : {{drDeleteRows.length}}</span>
                <!-- <b-button size="sm" variant="info" v-on:click="qaTemplateDeleteClear()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 초기화</h5></b-button> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <b-button variant="outline-danger" style="float:right" v-on:click="qaTemplateDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button>
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="slot_number" slot-scope="data">
                    <div style="width:100px">
                      <select :id="'slotSelect'+data.item.rnum" size="0" class="form-control" v-if="data.item.use_yn == 'Y'" v-on:change="slotOnChange(data.item, $event.target.value, data.item.rnum)">
                        <option v-for="optItem in selectSlotNumbers" :value="optItem.template_id+'|'+optItem.template_ord+'|'+optItem.title" :selected="optItem.template_ord == data.item.template_ord">{{optItem.template_ord}}</option>
                        <!-- <option value="2" :selected="2 == data.item.slot_number">2</option>
                        <option value="3" :selected="3 == data.item.slot_number">3</option>
                        <option value="4" :selected="4 == data.item.slot_number">4</option>
                        <option value="5" :selected="5 == data.item.slot_number">5</option> -->
                      </select>
                      <div v-if="data.item.use_yn == 'N'">비활성</div>
                    </div>
                  </template>
                  <template slot="use_yn" slot-scope="data">
                    <!-- <div><c-switch type="text" :id="'activeSelect'+data.item.rnum" variant="primary" v-model="data.item.use_yn" v-on:change="bannerActiveYN(data.item, data.item.rnum)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/></div> -->
                    <div><c-switch type="text" :id="'activeSelect'+data.item.rnum" variant="primary" v-model="data.item.use_yn" v-on:change="templateUseSwitch(data.item,data.item.template_id)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/></div>
                  </template>
                  <template slot="title" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="qaTemplateInfoGo(data.item)">{{data.item.title}}</a></div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/customer/qatemplate/form?status=insert'"><i class="fa fa-hand-o-up"></i> 신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import cSwitch from '../../components/Switch'

const moment = require("moment");

export default {
  components: {
    cSwitch
  },
  data() {
    return {
      reporturltype: this.$route.params.reporturltype,
      dr_topdeth_code: '',
      dr_rtype: '',
      slotNumValue: null,
      selectSlotNumbers: [],
      resultCateDatas: [], // code.js 각 코드들의 결과값
      selectCateItems: [], // 상단 구분 셀렉트 박스 코드값
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      drDeleteRows: [],
      searchData: {},
      queryParams: {
        day_code: 'dayall',
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      slotParams:{},
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '70px'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '100px'
          }
        }
      }, {
        'use_yn': {
          'label': '사용여부',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '120px'
          }
        }
      }, {
        'slot_number': {
          'label': '슬롯번호',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center',
             'width':'100px'
          }
        }
      }, {
        'title': {
          'label': '제목',
          // 'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'reg_id': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '120px'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '150px'
          }
        }
      }],
      items: [],
      dateMonthButtons: [
        { item_name: '전체', item_code:'dayall', state: true },
        { item_name: '오늘', item_code:'-1|days',state: false },
        { item_name: '1주일', item_code:'-7|days',state: false },
        { item_name: '1개월', item_code:'-1|months',state: false },
        { item_name: '6개월', item_code:'-6|months',state: false },
        { item_name: '1년', item_code:'-1|years',state: false },
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'slotNumValue' (newValue, oldValue) {
      // console.log(newValue);
      // console.log(oldValue);
    },
  },
  mounted: function() {
     // /contents/trendbrief
     this.templateInit();
  },
  methods: {
    templateInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.searchData = {};
      self.queryParams = {
        day_code: 'dayall',
        start_date: moment().add(0, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      };

      self.dateMonthButtons.forEach(function (el, idx, arr){
        if(idx == 0){
          el.state = true;
        }else{
          el.state = false;
        }
      });

      // 최초 리스트 갱신
      self.findQATemplateList();
    },
    // 템플릿 리스트 조회
    findQATemplateList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/qaTemplateList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.selectSlotNumbers = [];
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
            if(el.use_yn == 'Y'){
              self.selectSlotNumbers.push(el);
            }
          });
          // console.log('self.selectSlotNumbers',self.selectSlotNumbers);
          // self.searchData.startday = self.queryParams.start_date;
          // self.searchData.endday = self.queryParams.end_date;
          // self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
        })
    },
    qaTemplateInfoGo(row) {
      var self = this;
      self.$session.set('templateCode', row.template_id);
      location.href = '#/customer/qatemplate/info';
    },
    slotOnChange(data, value, selectNum){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var items = data;
      var preSlotNumArr = value.split("|");
      if(data.template_ord != preSlotNumArr[1]){
        swal.fire({
          title: '순서 설정!',
          html: "<strong>이전 순서 - "+preSlotNumArr[2]+"("+preSlotNumArr[1]+")</br>변경 순서 - "+items.title+"(<span style='color:red'>"+items.template_ord+" => "+preSlotNumArr[1]+"</span>)</strong></br>변경 하시겠습니까?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'OK'
        }).then((swalResult) => {
          if (swalResult.value) {
            self.slotParams.template_id = items.template_id;
            self.slotParams.template_ord = items.template_ord;
            self.slotParams.old_template_id = preSlotNumArr[0];
            self.slotParams.old_template_ord = preSlotNumArr[1];
            self.slotParams.reg_id = self.$session.get('userId');
            var param = encodeURI(JSON.stringify(self.slotParams));
            var data = new FormData();
            data.append('objs', param);

            // console.log(self.slotParams);
            self.$http.post('/api/update/qaTemplateOrd?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '순서가 설정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    $("#slotSelect"+selectNum).val(items.template_id+'|'+items.template_ord+'|'+items.title);
                    self.findQATemplateList();
                });
            })
          }else{
            $("#slotSelect"+selectNum).val(items.template_id+'|'+items.template_ord+'|'+items.title);
          }
        })
      }
    },
    templateUseSwitch(item, template_id) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.reg_id = self.$session.get('userId');
      self.queryParams.template_id = template_id;
      self.queryParams.use_yn = item.use_yn;

      // console.log(self.queryParams);
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/update/qaTemplateUseYn?access_token='+token, data, null)
        .then((result) => {
          self.queryParams.use_yn = '';
          self.findQATemplateList();
      })
    },
    drListRows() {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.template_id);
        }
      });
    },
    qaTemplateDelete(){
      var self = this;
      swal.fire({
        title: '답변 템플릿 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 답변 템플릿</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          // console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/qaTemplateList?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '답변 템플릿이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findQATemplateList();
              });
          })
        }else{
          // cansel
        }
      })
    },

    // bannerActiveYN(data, selectNum){
    //   var self = this;
    //   var token = sessionStorage.getItem("myToken");
    //   var items = data;
    //   var oldActive = (items.use_yn == 'Y'?'N':'Y');
    //   var newActive = items.use_yn;

    //   if(oldActive == 'Y' && self.selectSlotNumbers.length == 1 ){
    //     data.use_yn = oldActive;
    //     $("#activeSelect"+selectNum).find("input:checkbox[class='switch-input']").prop("checked", true);
    //     swal.fire(
    //       '배너는 최소 1개 이상<br/> 게재되어야 합니다!',
    //       '',
    //       'warning'
    //     ).then(function() {
    //       self.findQATemplateList();
    //     });
    //   }else{
    //     self.$http.get('/api/update/bannerActiveYn?access_token='+token + '&bannercode='+items.banner_code + '&newactive='+newActive+'&banner_type=mainbanner')
    //     .then((result) => {
    //       // swal.fire(
    //       //   '적용 되었습니다.',
    //       //   '',
    //       //   'success'khhw
    //       // ).then(function() {
    //       //
    //       // });
    //       self.findQATemplateList();
    //     })
    //   }
    // },
  },
}
</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
</style>



// WEBPACK FOOTER //
// src/views/customer/QATemplateList.vue